import Ajv from 'ajv';
import { WeekdayConst } from '@axiom/const';

import { axiomValidationOptions } from './options';

const ajv = new Ajv(axiomValidationOptions());

const generateNotificationsValidation = {
  type: 'object',
  additionalProperties: false,
  properties: {
    weeklyNotificationsDay: {
      type: 'string',
      enum: Object.keys(WeekdayConst),
    },
  },
};

export const generateNotificationsValidator = ajv.compile(
  generateNotificationsValidation
);
